exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nform#formulario_consulta[data-v-7b08623e] {margin-bottom: 20px;}\n", ""]);

// exports
